const TmpPE001 = (page) => {
  const modifiedPage = {
    ...page,
  };

  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: [],
    eMentor: [],
    focusPoints: [],
  };

  return { modifiedPage, metadata };
};

export default TmpPE001;